import { createFileRoute } from '@tanstack/react-router';
import { parse, object, string, optional } from 'valibot';

export const Route = createFileRoute('/(authenticated)/patients/$patientId/')({
  validateSearch: (search) => {
    return parse(
      object({
        cpid: optional(string()),
        panel: optional(string()),
        taskId: optional(string()),
      }),
      search,
    );
  },
});
